// extracted by mini-css-extract-plugin
export default {"container":"Baner_container__8shAJ","circleGroup":"Baner_circleGroup__57i7x"};